import axios from '@/utils/axios'
// 组件列表
export function list(query) {
    return axios({
        url: '/novelRechargeTemplate/list',
        method: 'get',
        params: query
    })
}

// 添加
export function add(query) {
    return axios({
        url: '/novelRechargeTemplate/addOrUpdTemplate/save',
        method: 'post',
        params: query
    })
}
// 删除
export function del(query) {
    return axios({
        url: '/novelRechargeTemplate/delTemplate/save',
        method: 'post',
        params: query
    })
}
// 详情
export function details(query) {
    return axios({
        url: '/novelRechargeTemplate/getRechargeTemplateById',
        method: 'get',
        params: query
    })
}
// 签约模板
export function listSign(query) {
    return axios({
        url: '/signingTemplate/getSigningTemplateList',
        method: 'get',
        params: query
    })
}
// 签约模板详情
export function detailsSign(query) {
    return axios({
        url: '/signingTemplate/getSigningTemplateById',
        method: 'get',
        params: query
    })
}
// 添加签约模板
export function listSignAdd(query) {
    return axios({
        url: '/signingTemplate/addOrUpdSigningTemplate',
        method: 'post',
        data: query
    })
}
// 屏蔽签约模板
export function shield(query) {
    return axios({
        url: '/signingTemplate/shield',
        method: 'post',
        params: query
    })
}
//配置方案组件列表
export function waylist(query) {
    return axios({
        url: '/novelRechargeTemplate/Plan/list',
        method: 'get',
        params: query
    })
}

// 充值方案配置详情
export function wayDetails(query) {
    return axios({
        url: '/novelRechargeTemplate/getRechargePlanConfigInfo',
        method: 'get',
        params: query
    })
}

// 充值方案-添加
export function wayAdd(query) {
    return axios({
        url: '/novelRechargeTemplate/addOrEditRechargePlanInfo/save',
        method: 'post',
        params: query
    })
}

// 充值方案配置-添加档位
export function listWayAdd(query) {
    return axios({
        url: '/novelRechargeTemplate/addPlanTemplateData/save',
        method: 'post',
        params: query
    })
}
// 删除已配置的档位
export function delWay(query) {
    return axios({
        url: '/novelRechargeTemplate/delConfigTemplate/save',
        method: 'post',
        params: query
    })
}

//方案档位排序
export function planOrder(query) {
    return axios({
        url: '/novelRechargeTemplate/planData/order',
        method: 'post',
        params: query
    })
}

// 充值方案配置- 档位选中
export function selected(query) {
    return axios({
        url: '/novelRechargeTemplate/addSelectionOfPlanTemplate',
        method: 'post',
        params: query
    })
}